export type DisplayMode = 'MobilePortrait' | 'MobileLandscape' | 'PC';

export const isMobileDisplayMode = (m: DisplayMode) =>
  m === 'MobilePortrait' || m === 'MobileLandscape';

export const gameSupportsMobile = (modes?: DisplayMode[]) => !!modes?.some(isMobileDisplayMode);

export interface Project {
  id: string;
  name: string;
  version: string;
  platform: 'Windows' | 'Android' | 'iOS' | 'Mac' | 'Web';
  type?: '2D' | '3D';
  creditsUsed?: number;
  totalGeneratedImages?: number;
  supportedDisplayModes?: DisplayMode[];
  thumbnailUrl?: string;
  engineUpgradeRequired?: boolean;
}
